/**
 * v3.19 自媒体：预置头像（emoji + 背景色）。
 *
 * 去中心化平台上头像上链/上传属于后续（链端 content 支持后才可跨端一致）；
 * 本版本使用「本机预置头像」：用户从预置库选择，存 localStorage（mesh_avatar），
 * 未设置时按 DID 哈希确定性分配，保证同一作者在不同设备/列表里头像稳定。
 */

export const AVATAR_EMOJIS = [
  '🦊', '🐼', '🚀', '🌊', '🎮', '📸', '🎵', '🏆',
  '🦉', '🐳', '🌵', '⚡', '🍀', '🔥', '🪐', '🎨',
] as const;

export const AVATAR_BGS = [
  '#1f6feb', '#238636', '#bf8700', '#a4343a', '#8250df', '#0e8a83', '#9a6700', '#57606a',
] as const;

export interface AvatarValue {
  emoji: string;
  bg: string;
}

const LS_KEY = 'mesh_avatar';

/** 读取本机头像设置（未设置返回 null）。 */
export function loadAvatar(): AvatarValue | null {
  try {
    const raw = window.localStorage.getItem(LS_KEY);
    if (!raw) return null;
    const p = JSON.parse(raw) as Partial<AvatarValue>;
    if (typeof p.emoji !== 'string' || typeof p.bg !== 'string') return null;
    return { emoji: p.emoji, bg: p.bg };
  } catch {
    return null;
  }
}

/** 保存本机头像设置。 */
export function saveAvatar(v: AvatarValue): void {
  try {
    window.localStorage.setItem(LS_KEY, JSON.stringify(v));
  } catch {
    /* 存储满忽略 */
  }
}

/** 确定性头像：给定 did/address，稳定分配到预置库（同一作者处处一致）。 */
export function avatarFor(key: string): AvatarValue {
  const own = loadAvatar();
  if (own) return own;
  let h = 0;
  const s = String(key ?? '');
  for (let i = 0; i < s.length; i += 1) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return {
    emoji: AVATAR_EMOJIS[h % AVATAR_EMOJIS.length],
    bg: AVATAR_BGS[(h >> 3) % AVATAR_BGS.length],
  };
}
